export enum RegistrationFeature {
  AccordionCustomContent = 'accordionCustomContent',
  ApplianceDetailsModelSerial = 'applianceDetailsModelSerial',
  ApplianceDetailsSteppedForm = 'applianceDetailsSteppedForm',
  ApplianceSpecificContent = 'applianceSpecificContent',
  CanRemoveApplianceRegistration = 'canRemoveApplianceRegistration',
  ExtraYearsWarrantyMessage = 'extraYearsWarrantyMessage',
  GroupMarketingPreferences = 'groupMarketingPreferences',
  MarketingPreferences = 'marketingPreferences',
  MultiPlan = 'multiPlan',
  MultiRegistration = 'multiRegistration',
  PrivacyPolicyCheckbox = 'privacyPolicyCheckbox',
  ProtectionUpsellCheckbox = 'protectionUpsellCheckbox',
  ProtectionUpsellPage = 'protectionUpsellPage',
  SeoNoIndexMetaTag = 'seoNoIndexMetaTag',
}
